var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 19.8494H12M1.5 20.3494L7.04927 18.2151C7.40421 18.0786 7.58168 18.0103 7.74772 17.9212C7.8952 17.842 8.0358 17.7507 8.16804 17.648C8.31692 17.5325 8.45137 17.3981 8.72028 17.1291L20 5.84943C21.1046 4.74486 21.1046 2.95399 20 1.84942C18.8955 0.744855 17.1046 0.744853 16 1.84942L4.72028 13.1291C4.45138 13.3981 4.31692 13.5325 4.20139 13.6814C4.09877 13.8136 4.0074 13.9542 3.92823 14.1017C3.83911 14.2677 3.77085 14.4452 3.63433 14.8002L1.5 20.3494ZM1.5 20.3494L3.55812 14.9984C3.7054 14.6155 3.77903 14.424 3.90534 14.3363C4.01572 14.2597 4.1523 14.2307 4.2843 14.2559C4.43533 14.2847 4.58038 14.4298 4.87048 14.7199L7.12957 16.979C7.41967 17.2691 7.56472 17.4141 7.59356 17.5652C7.61877 17.6971 7.58979 17.8337 7.51314 17.9441C7.42545 18.0704 7.23399 18.1441 6.85107 18.2913L1.5 20.3494Z",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.45207dd7b6205ede1b29db495ce2b248.svg";
export { ForwardRef as ReactComponent };